import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/auth/:type`;

export const authManagementRoutesObj = {
  auth: baseRoute,
} as const;

export type IAuthManagementRouteParams = IExtractRouteParamMap<
  typeof authManagementRoutesObj
>;

export const authManagementPath = createPaths<
  typeof authManagementRoutesObj,
  IAuthManagementRouteParams
>(authManagementRoutesObj);
